import { useEffect, useState } from "react";
import { _CashReimbursementItem, _CashRequest, _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { Singleton } from "../../../../core/services/Singleton";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { CashRequestItem } from "../CashResquestItems/CahsRequestItems";
import { AccountEditor } from "../../../editor/AccountEditor";
import { CashRequestConstantSelector } from "./CashRequestConstantSelector";
import { CashDeskAccountSelector } from "../CashDeskAccount/CashDeskAccountSelector";
import { CashRequestMoney } from "../CashRequestMoney/CashRequestMoney";
import { CashRequestRefundConstantsSelector } from "./CashRequestRefundConstantsSelector";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useModal, { MODAL_LG, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { ErrorList } from "../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SelectInboxCash } from "../CashDesk/SelectInboxCash";
import { OfficeEditor } from "../Office/OfficeEditor";
import { CashRequest } from "./CahsRequest";
import { CashRequestBudget } from "./CashRequestBudget/CashRequestBudget";


export const ManageCahsRequest = () => {

    const { lista, setLista, bean, setBean, instance, handleChange } = useDataBean(_CashRequest);
    const single = Singleton.getInstance();

    const [year, setYear] = useState<number>(single.getCurrenYear());
    const [account, setAccount] = useState<number>(NaN);
    const [state, setState] = useState<number>(3);
    const [cashID, setCashID] = useState<number>(NaN);
    const [obs, setObs] = useState<string>("");
    const _documentos = useDataBean(_DocumentFactory);
    const [docslegal, setDocslegal] = useState<any>([]);
    const [response, setResponse] = useState<any>({});
    const [refund, setRefund] = useState<any>({});
    const [refundResponse, setRefundResponse] = useState<any>();
    const [docs, setDocs] = useState<any>([]);
    const [docsTWO, setDocsTWO] = useState<any>([]);
    const [legalizar, setlegalizar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdocdos, setModalverdocdos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalinforme, setModalinforme] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalItems, setModalItems] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });
    const [modalAdvance, setModalAdvance] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalRefund, setModalRefund] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalHisotry, setModalHistory] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalVisor, setModalVisor] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const modalDocument = useModal("Documento Contable", MODAL_XL);
    const modalAddRequest = useModal("Crear una Solicitud de Pago por Caja Menor", MODAL_LG);
    const modalThird = useModal("Consultar Solicitudes de Tercero", MODAL_XL);
    // const modalDoc = useModal("Documento Generado", MODAL_XL);

    // useEffect(() => {
    //     if (state && cashID) {
    //         getLista();
    //     }
    // }, [state, cashID])
    useEffect(() => {
        if (legalizar.view) {
            verDocumentos();
        }
    }, [legalizar.view]);
    const getLista = () => {
        instance.getCashRequestCatalogForState(single.getAccountID(), year, state, cashID).then(
            (resp) => {
                //console.log(resp)
                setLista(resp)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const processRequest = () => {
        instance.processCashRequest(bean.IDCashRequest, bean.CashRequestDate, single.getAccountID(), obs).then(
            (resp) => {
                setModal({ ...modal, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err);
            }
        )
    }

    const rejectRequest = () => {
        instance.rejectCashRequest(bean.IDCashRequest, bean.CashRequestDate, single.getAccountID(), obs).then(
            (resp) => {
                setModalConfirm({ ...modalConfirm, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err);
            }
        )

    }

    const payAdvance = () => {
        instance.addAdvanceValueToCashRequest(bean.IDCashRequest, bean.CashRequestDate, response.Obs, parseInt(response.Value), response.AccountantDate, single.getAccountID()).then(
            (resp) => {
                setDocs(resp.DocumentURL);
                setModalAdvance({ ...modalAdvance, "view": false });
                setModalverdoc({ ...modalverdoc, "view": true });
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    //conflictos por resolver
    const payRefund = () => {
        //console.log(bean.IDCashRequest, bean.CashRequestDate, refund.Type, null, refund.Obs, parseInt(refund.Value), single.getAccountID())
        instance.getCashReceiptToCashRequest(bean.IDCashRequest, bean.CashRequestDate, refund.AccountantDate, refund.Obs, parseInt(refund.Value), _single.getAccountID()).then(
            (resp) => {
                setDocsTWO(resp.DocumentURL);
                setModalRefund({ ...modalRefund, "view": false });
                setModalverdocdos({ ...modalverdocdos, "view": true });

            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDCashRequest', mask: MASK_NUMBER },
        { title: 'Fecha Solicitud', property: 'CashRequestDate' },
        { title: 'Solicitado por', property: 'AccountName' },
        { title: 'Descripción', property: 'Description' },
        { title: 'Estado de Legalización', property: 'StateName' },
        { title: 'Estado de la Operación', property: 'OrderStateName' },

        { title: 'Solicitante', property: 'AccountName' },
        { title: 'Requiere Anticipo', property: 'RequiresAdvance' },
        { title: 'Anticipo Solicitado', property: 'AdvanceValue', mask: MASK_MONEY },
        { title: 'Anticipo Pagado', property: 'AdvanceApprovedValue', mask: MASK_MONEY },
        { title: 'Documento', property: 'AdvanceDocumentConsecutive' },
        { title: 'Valor Rembolsado', property: 'Value', mask: MASK_MONEY },
        { title: 'Caja Solicitada', property: 'CashDeskAccountName' },
        { title: 'Responsable de Caja', property: 'IDEmployeeName' },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Informe de Rubros Presupuestales Legalizados', icono: 'ri-file-list-line', visible: true, evento: () => { setModalinforme({ ...modalinforme, "view": true }) } },
            { titulo: "Ver Documento de Legalización", icono: "ri-file-list-line", visible: true, evento: () => { setlegalizar({ ...legalizar, "view": true }) }, },
            { titulo: "Marcar solicitud Procesada", icono: "ri-check-line", visible: (bean.OrderState !== 4 && bean.OrderState !== 5), evento: () => { setModal({ ...modal, view: true, name: "Marcar solicitud Procesada" }); }, },
            { titulo: "Realizar Anticipo a Solicitud de Caja Menor", icono: "ri-money-dollar-box-line", visible: (bean.OrderState !== 4 && bean.OrderState !== 5), evento: () => { setModalAdvance({ ...modalAdvance, view: true, name: `Realizar Anticipo` }); }, },
            { titulo: "Realizar Reintegro", icono: "ri-exchange-dollar-line", visible: (bean.OrderState !== 4 && bean.OrderState !== 5), evento: () => { setModalRefund({ ...modalRefund, view: true, name: `Realizar Reintegro` }); setRefund({}) }, },
            { titulo: "Ver Anticipos y Reintegros", icono: "ri-eye-line", visible: (bean.OrderState !== 4 && bean.OrderState !== 5), evento: () => { setModalHistory({ ...modalHisotry, view: true, name: `Anticipos y Reintegros` }); }, },
            { titulo: "Rechazar Solicitud", icono: "ri-close-line", visible: (bean.OrderState !== 4 && bean.OrderState !== 5), evento: () => { setModalConfirm({ ...modalConfirm, view: true, name: `Rechazar Solicitud` }); }, },
            { titulo: "Ver Facturas de la solicitud", icono: "ri-file-list-line", visible: single.canEdit(), evento: () => { setModalItems({ ...modalItems, "name": "Items de la solicitud de Pago", "view": true }) }, },
            { titulo: "Ver Documento", icono: "ri-eye-line", visible: single.canEdit(), evento: () => { getDocument(bean.DocIDDocument, bean.DocDate) }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    useEffect(() => {
        setObs("");
    }, [modal, modalConfirm])

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validatePayAdvance = () => {
        if (validateForm("advance") > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            payAdvance();
        }
    }

    const validatePayRefund = () => {
        if (validateForm("refund") > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            payRefund();
        }
    }

    const validateForm = (type: "refund" | "advance") => {
        let missing = [];

        if (type == "refund") {
            const requiredFields = [
                "Value", "Obs", "AccountantDate"
            ];

            for (let field of requiredFields) {
                if (refund[field] === null || refund[field] === undefined || refund[field] === "") {
                    missing.push(field);
                }
            }
        } else if (type == "advance") {
            const requiredFields = [
                "Value", "Obs", "AccountantDate"
            ];

            for (let field of requiredFields) {
                if (response[field] === null || response[field] === undefined || response[field] === "") {
                    missing.push(field);
                }
            }
        }

        //console.log(missing)
        setMissingFields(missing);
        return missing.length
    };

    const doc = useDataBean(_DocumentFactory);
    const [msgList, setMsgList] = useState<any>([]);

    // useEffect(() => {
    //     if (refundResponse != "") {
    //         modalDoc.open();
    //     }
    // }, [refundResponse])

    const getDocument = (idDocument: number, docDate: any) => {
        doc.instance.getAccountantDocumentByLocation(idDocument, docDate).then(
            (resp) => {
                doc.setLista(resp.DocumentURL)
                modalDocument.open()
                setMsgList(resp.MsgList);
            }
        ).catch(err => { toast.error(err) })
    }

    const validateAdd = () => {
        if (validateFormAdd() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            updateItem();
        }
    }

    const validateFormAdd = () => {
        let missing = [];

        const requiredFields = [
            "Description", "CashRequestDate", "IDAccount", "IDCashDeskAccount"
        ];

        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        //cambios para validar cambios de andres
        //console.log(missing)
        setMissingFields(missing);
        return missing.length
    };

    const updateItem = () => {
        instance.updateCashRequest(bean).then(
            (resp) => {
                getLista();
                modalAddRequest.close();
                toast.success("Se creo la Solicitud Satisfactoriamente")
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    const verDocumentos = () => {

        if (bean) {
            _documentos.instance.getPdfAccountantDocument(bean.DocIDDocument, null, bean.DocDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocslegal(resp.DocumentURL);
                    setlegalizar({ ...legalizar, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const createItem = () => {
        setBean({
            OrderState: 3,
            RequiresAdvance: false,
        });
        modalAddRequest.open();
    }

    const iconButtonsItem = [
        { nombre: "Crear Solicitudes de Caja Menor de Terceros", visible: single.canCreate(), icono: "ri-file-add-line", evento: createItem },
        { nombre: "Consultar Solicitudes de Tercero", visible: true, icono: "ri-eye-line", evento: () => { modalThird.open() } },
    ];

    const [office, setOffice] = useState<any>();

    return (
        <>
            <BasicPage titulo="Solicitudes Recibidas para Caja Menor">
                <div className="row">
                    <div className="col-3">
                        <AccountEditor label="Solicitante" idAccount={account} onChange={({ IDAccount }) => { setAccount(IDAccount) }} />
                    </div>
                    <div className="col-2">
                        <YearSelector onChange={(e) => { setYear(e) }} value={year} />
                    </div>
                    <div className="col-4">
                        <CashRequestConstantSelector idSelector={state} onChange={(e) => setState(e)} />
                    </div>
                    <div className="col-md-3">
                        <CashDeskAccountSelector id={cashID} onchange={(e) => { setCashID(e) }} idAccount={single.getAccountID()} />
                    </div>
                    <div className="col-md-2">
                        <BasicButton icon="ri-search-line" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                            <div className="row">
                                <DocumentViewer
                                    list={docs}
                                />
                            </div>
                        </Modal>
                        <Modal modal={modalverdocdos} updateModal={setModalverdocdos}>
                            <div className="row">
                                <DocumentViewer
                                    list={docsTWO}
                                />
                            </div>
                        </Modal>
                        <Modal modal={modalinforme} updateModal={setModalinforme}>
                            <div className="row">
                                <CashRequestBudget idCashRequest={bean.IDCashRequest} cashRequestDate={bean.CashRequestDate} />
                            </div>
                        </Modal>
                    </div>
                </div>

            </BasicPage>
            <div className="col-md-12">
                <Modal modal={legalizar} updateModal={setlegalizar}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docslegal}
                                IDDocument={bean.DocIDDocument}
                                Since={bean.DocDate}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
            <Modal modal={modal} updateModal={setModal} eventModal={processRequest} >
                <div className="col-12">
                    <label>Observaciones</label>
                    <textarea value={obs} name="Observations" className="form-control" onChange={(e) => { setObs(e.target.value) }} rows={4} />
                </div>
            </Modal>

            <Modal modal={modalConfirm} updateModal={setModalConfirm} eventModal={rejectRequest} >
                <div className="col-12">
                    <label>Observaciones</label>
                    <textarea value={obs} name="Observations" className="form-control" onChange={(e) => { setObs(e.target.value) }} rows={4} />
                </div>
            </Modal>

            <Modal modal={modalAddRequest.modal} updateModal={modalAddRequest.setModal} eventModal={validateAdd} >
                <div className="row">
                    {/* <PrintJson json={bean} /> */}
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Usuario</label>
                        <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('CashRequestDate') ? 'has-error' : ''}`}>Fecha de la solicitud</label>
                        <InputDate name="CashRequestDate" label=" " value={bean.CashRequestDate} setDate={(e) => { setBean({ ...bean, "CashRequestDate": e }) }} notDate={!bean.CashRequestDate} />
                    </div>
                    <div className="col-md-6 ">
                        <BasicSwitch estado={bean.RequiresAdvance} eventChange={(e) => { setBean({ ...bean, "RequiresAdvance": e }) }} label="Requiere Anticipo" />
                    </div>
                    {bean.RequiresAdvance &&
                        <div className="col-md-6">
                            <InputMoney _label="Valor a Anticipar" _value={bean.AdvanceValue} onChange={(e) => { setBean({ ...bean, "AdvanceValue": e }) }} />
                        </div>
                    }
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('IDCashDeskAccount') ? 'has-error' : ''}`}>Ciudad</label>
                        <OfficeEditor label=" " id={office} idconpany={null} onchange={(e: any) => { setOffice(e) }} />
                    </div>
                    {office &&
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDCashDeskAccount') ? 'has-error' : ''}`}>Caja Menor</label>
                            <SelectInboxCash city={office} label=" " idSelector={bean.IDCashDeskAccount} onChange={(e) => { setBean({ ...bean, IDCashDeskAccount: e }) }} />
                        </div>
                    }
                    <div className="col-12">
                        <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`}>Descripción</label>
                        <textarea value={bean.Description} name="Description" className="form-control" onChange={handleChange} rows={4} />
                    </div>

                </div>
            </Modal>

            <Modal modal={modalThird.modal} updateModal={modalThird.setModal} >
                <div className="row">
                    <div className="col-md-12">
                        <CashRequest seachUser isModal />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} >
                <div className="row">
                    <div className="col">
                        {msgList.length > 0 &&
                            <ErrorList lista={msgList} />
                        }
                        {msgList.length === 0 && doc.lista.length > 0 &&
                            <DocumentViewer key={doc.lista} list={doc.lista} />
                        }
                    </div>
                </div>
            </Modal>

            {/* <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal}>
                {msgList.length > 0 &&
                    <ErrorList lista={msgList} />
                }
                {msgList.length === 0 && doc.lista.length > 0 &&
                    <DocumentViewer key={doc.lista} list={doc.lista} />
                }
            </Modal> */}

            <Modal modal={modalAdvance} updateModal={setModalAdvance} eventModal={validatePayAdvance} >
                <div className="row">
                    <div className="col-md-6">
                        <InputMoney _label="Valor Solicitado" readonly _value={bean.AdvanceValue} onChange={(e) => { }} />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor a Anticipar</label>
                        <InputMoney _label=" " _value={response.Value} onChange={(e) => { setResponse({ ...response, "Value": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('AccountantDate') ? 'has-error' : ''}`}>Fecha de Registro Contable</label>
                        <InputDate label=" " name="" notDate value={response.AccountantDate} setDate={(e) => { setResponse({ ...response, AccountantDate: e }) }} />
                    </div>
                    <div className="col-12">
                        <label className={`${missingFields.includes('Obs') ? 'has-error' : ''}`}>Observaciones</label>
                        <textarea value={response.Obs} name="Observations" className="form-control" onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} rows={4} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalRefund} updateModal={setModalRefund} eventModal={validatePayRefund} >
                <div className="row">
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('AccountantDate') ? 'has-error' : ''}`}>Fecha de Registro Contable</label>
                        <InputDate name="" value={refund.AccountantDate} notDate setDate={(e) => { setRefund({ ...refund, AccountantDate: e }) }} />
                    </div>
                    {/* <div className="col-md-6">
                        <label className={`${missingFields.includes('Type') ? 'has-error' : ''}`}>Tipo de Reintegro</label>
                        <CashRequestRefundConstantsSelector label=" " idSelector={refund.Type} onChange={(e) => { setRefund({ ...refund, "Type": e }) }} />
                    </div> */}
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor a Reintegro</label>
                        <InputMoney _label=" " onChange={(e) => { setRefund({ ...refund, "Value": e }) }} _value={refund.Value} />
                    </div>
                    <div className="col-12">
                        <label className={`${missingFields.includes('Obs') ? 'has-error' : ''}`}>Observaciones</label>
                        <textarea value={refund.Obs} name="Observations" className="form-control" onChange={(e) => { setRefund({ ...refund, "Obs": e.target.value }) }} rows={4} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalItems} updateModal={setModalItems} >
                <CashRequestItem _idCashAccount={cashID} entry="Manage" idCashRequest={bean.IDCashRequest} cashRequestDate={bean.CashRequestDate} idAccount={bean.IDAccount} />
            </Modal>

            <Modal modal={modalHisotry} updateModal={setModalHistory} >
                <CashRequestMoney cashRequestDate={bean.CashRequestDate} idCashRequest={bean.IDCashRequest} />
            </Modal>

            <Modal modal={modalVisor} updateModal={setModalVisor} >
                {msgList.length > 0 &&
                    <ErrorList lista={msgList} />
                }
                {msgList.length === 0 && doc.lista.length > 0 &&
                    <DocumentViewer key={doc.lista} list={doc.lista} />
                }
            </Modal>
        </>
    )
}